module.exports = {
    title: "e店佳_惠合科技门店营销活动平台_让营销服务数字智能化",
    description: "惠合科技“e店佳”是面向门店端的营销活动平台，为门店主提供从信息获取、任务执行到奖励领取的全流程服务，缩小品牌管理半径，保障营销费用100%实投。",
    keywords: "AI图像识别,品牌活动信息,店主社区,营销奖励,惠合科技,e店佳"
}